import { AfterViewInit, ComponentFactoryResolver, ComponentRef, Directive, ElementRef, HostListener, Injector, Input, NgZone, OnDestroy, OnInit, Optional, Renderer2 } from '@angular/core';
import { reqAnimFrame } from '@farris/ui-common';
import { InputGroupComponent } from '@farris/ui-input-group';
import { from, fromEvent, Observable } from 'rxjs';
import { debounceTime, filter, map } from 'rxjs/operators';

import { LookupGridDisplayType, QuickSelectOption } from '../lookup-displaytype';
import { DisplayInfo, LOAD_DATA_TYPE, LookupGridResult, PickingResult } from '../lookup-grid-options';
import { LookupGridComponent } from '../lookup-grid.component';
import { LookupQuickSelectPanelComponent } from './quick-select-panel.component';

@Directive({ selector: '[quick-select]'})
export class LookupQuickSelectDirective implements OnInit, AfterViewInit, OnDestroy {
    @Input('quick-select') options: QuickSelectOption;
    private panelElement: HTMLElement;
    private cmpRef: ComponentRef<LookupQuickSelectPanelComponent>;

    private data = [];

    constructor(private injector: Injector, private ngzone: NgZone, private render: Renderer2, private inputRef: InputGroupComponent, private lookupRef: LookupGridComponent,
        private cfr: ComponentFactoryResolver) {
    }

    ngOnInit(): void {
        
    }

    ngAfterViewInit(): void {
        if (this.options && this.options.enable) {
            this.inputRef.inputClick.subscribe((e: MouseEvent) => {
                e.stopPropagation();
                // tfs 649804
                if (!this.panelElement && (this.lookupRef && !this.lookupRef.readonly && !this.lookupRef.disabled)) {
                    // æ§è¡å¸®å©å
                    this.lookupRef.dictPicking({
                        instance: this,
                    }).subscribe((pr: PickingResult) => {
                        if (this.lookupRef.displayType === LookupGridDisplayType.TreeList || (!this.lookupRef.singleSelect && this.lookupRef.viewType === 'text')) {
                            return;
                        }
                        const { show, customData, message } = this.lookupRef.dialogMgr.checkDictPickingResult(pr);
                        this.lookupRef.customData = customData;
                        if (show) {
                            this.createDataPanel();
                        } else {
                            if (message) {
                                this.lookupRef.notifyService.warning(message);
                            }
                        }
                    })
                }
            });

            this.inputRef.valueChange.pipe(
                debounceTime(200)
            ).subscribe((val: string) => {
                this.lookupRef.dictPicking({instance: this}).subscribe((pr: PickingResult) => {
                    if (this.lookupRef.displayType === LookupGridDisplayType.TreeList || (!this.lookupRef.singleSelect && this.lookupRef.viewType === 'text')) {
                        return;
                    }
                    const { show, customData, message } = this.lookupRef.dialogMgr.checkDictPickingResult(pr);
                    this.lookupRef.customData = customData;
                    if (!this.panelElement) {
                        this.createDataPanel();
                    } else {
                        this.panelElement.style.overflow = 'hidden';
                        this.setPanelPosition(false);
                        this.loadData();
                    }
                })
            });

            this.inputRef.keydownHandle.pipe(
                filter((event: KeyboardEvent) => {
                    return event.key === 'Escape' || event.key === 'Tab' ||  event.key === 'F2';
                })
            ).subscribe((e) => {
                this.hide(e);
            });
        }
    }

    ngOnDestroy(): void {
        this.lookupRef.overLayService.destory(this.lookupRef.el.nativeElement);
    }

    private removePanelElement() {
        document.body.removeChild(this.panelElement);
        this.panelElement = null;
    }

    private clearSearchValue() {
        this.lookupRef._searchState = { 
            field: '*', //"*",
            value: ''
        }
    }

    hide(e?: any, isMoreClick = false) {
        reqAnimFrame(() => {
            if (this.panelElement) {
                if (e && ( e.type === 'mousewheel' || e.type === 'wheel')) {
                    this.removePanelElement();
                } else {
                    this.panelElement.classList.remove('f-area-show');
                    setTimeout(() => {
                        this.removePanelElement();
                    },120);
                }

                if (!this.lookupRef) {
                    return;
                }

                
                // tfs 579056
                if (this.lookupRef.overLayService) {
                    this.lookupRef.overLayService.destory(this.lookupRef.el.nativeElement);
                }

                if (isMoreClick) {
                    return;       
                }

                if (this.lookupRef.tagInput) {
                    // this.lookupRef.tagInput.value = '';
                    this.inputRef.value = '';
                    this.clearSearchValue();
                }

                if (e && (e.key === 'F2' || this.lookupRef.el.nativeElement.contains(e.target))) {
                    if (this.data && this.data.length) {
                        return;
                    } else {
                        this.clearSearchValue();
                    }
                }

                if (!this.lookupRef.nosearch && this.lookupRef.displayText !== this.lookupRef.originalText) {
                    this.lookupRef.onChanges(this.lookupRef.originalText)
                }
            }
        });
    }

    private setPanelPosition(updateTopPosition = true) {
        if (this.panelElement) {
            const { width, left, top, height } = this.getPanelSize();
            this.panelElement.style.width = `${width}px`;
            this.panelElement.style.maxHeight = `${height}px`;
            if (updateTopPosition) {
                this.panelElement.style.top = `${top}px`;
            }
            this.panelElement.style.left = `${left}px`;
            this.panelElement.style.zIndex = '10001';
        }
    }

    private createDataPanel() {
        
        if (this.lookupRef.changeDetector['destroyed']) {
            this.panelElement && this.removePanelElement();
            return;
        }

        this.panelElement = document.createElement('div');
        this.panelElement.classList.add('overlay-pane', 'f-lookup_quick-panel', 'f-area-hide');

        document.body.appendChild(this.panelElement);
        this.setPanelPosition();

        this.panelElement.style.overflow = 'hidden';
        // this.panelElement.style.height = 'auto';
        
        // åå»ºæ°æ®å±ç¤ºç»ä»¶
        const cmpFact = this.cfr.resolveComponentFactory(LookupQuickSelectPanelComponent);
        this.cmpRef = cmpFact.create(this.injector);
        
        this.cmpRef.instance.showMore = this.options.showMore;
        this.cmpRef.instance.textField = this.lookupRef.textField;
        this.cmpRef.instance.formatter = this.options.formatter;
        this.cmpRef.instance.maxItems = this.options.showItemsCount;

        // cmpRef.location.nativeElement.classList.add('farris-main-area');
        this.panelElement.appendChild(this.cmpRef.location.nativeElement);

        this.lookupRef.selectionMgr.initDisplayValue();
        
        this.cmpRef.changeDetectorRef.detectChanges();

        // more clicked æå¼å¸®å©çªå£
        this.cmpRef.instance.moreClcik.subscribe((e) => {
            this.hide(e, true);
            this.lookupRef.showDialog();
        });

        this.cmpRef.instance.itemClick.subscribe((e: any) => {
            const { data } = e;
            this.selectItem(data);
        });


        // æ³¨åé¼ æ æ»è½®ï¼ç¹å»äºä»¶ï¼ç¨äºéèPanel
        this.lookupRef.overLayService.registerMouseEvent(this.lookupRef.el.nativeElement, (e: MouseEvent) => {
            if (!this.panelElement || e.target['closest']('.f-lookup_quick-panel')) {
                return;
            }
            
            if(this.lookupRef.inputGroup && this.lookupRef.inputGroup.textbox.nativeElement === e.target) {
                return false;
            }

            if(this.lookupRef.tagInput && this.lookupRef.tagInput.textbox.nativeElement === e.target) {
                return false;
            }

            if (this.cmpRef) {
                this.cmpRef.destroy();
                this.cmpRef = null;
            }

            this.clearSearchValue();

            this.hide(e);
        });

        this.panelElement.classList.add('f-area-show');

        this.loadData();
    }

    private selectItem(data: any) {
        if (!data) {
            return;
        }

        if (this.lookupRef.viewType === 'tag') {
            const isSelect = this.lookupRef.selections.find(n => n[this.lookupRef.idField] === data[this.lookupRef.idField]);
            if (!isSelect) {
                const selectItems: any = [...this.lookupRef.selections, data];
                this.lookupRef.selectItem(selectItems);
                this.lookupRef.lookupSelectionSer.loadSelections(selectItems);
            }
        } else {
            this.lookupRef.selectItem(data);
        }
        this.hide();
    }


    private calculationPanelHeight() {
        return this.options.showItemsCount * 30 + (this.options.showMore ? 50: 0) + (this.options.footerHeight||0) + 5;
    }

    private getInputSizeInfo() {
        const el: any = this.lookupRef.viewType === 'text' ? this.inputRef.inputGroup : this.lookupRef.tagbox;
        return el.nativeElement.getBoundingClientRect();
    }

    private getPanelSize() {
        let { width, height, top, left } = this.getInputSizeInfo();
        const bottom = window.innerHeight - height - top;
        let panelHeight = this.calculationPanelHeight();

        const h = top > bottom ? top : bottom;
        if (bottom > panelHeight) {
            top = top + height;
            // é¢æ¿ç±ä¸åä¸å±å¼
            this.panelElement.style.transformOrigin = '100% top';
        } else {
            if (top > bottom) {
                if (h < panelHeight) {
                    panelHeight = h - 10;
                    top = 10;
                } else {
                    top = top - parseInt('' + panelHeight, 10) - 5;
                }

                // é¢æ¿ç±ä¸åä¸å±å¼
                this.panelElement.style.transformOrigin = '100% bottom';

            } else {
                if (h < panelHeight) {
                    panelHeight = h - 10;
                }
                top = top + height;
            }
        }

        const minWidth = this.options.minWidth || 200;
        let _width =  width < minWidth? minWidth: width;
        if (window.innerWidth - left < _width) {
            left = left + width - _width;
        }

        return { width: _width, top, height: panelHeight, left };
    }

    private getData(): Observable<Array<any>> {
        let p: any = {
            pageInfo: {
                pageSize: this.options.showItemsCount,
                pageIndex: 1,
            },
        };
        let t: LOAD_DATA_TYPE = "all";
        if (this.lookupRef.isTextChange) {
            this.lookupRef._searchState = { 
                field: this.lookupRef.textField, //"*",
                value: this.lookupRef.displayText
            }
            p['search'] = this.lookupRef._searchState;
            t = 'search';
        } else {
            this.lookupRef._searchState = null;
        }

        if (this.lookupRef.viewType === 'tag') {
            if (this.lookupRef.tagInput.value !== '') {
                this.lookupRef._searchState = { 
                    field: this.lookupRef.textField, //"*",
                    value: this.lookupRef.tagInput.value
                }
                p['search'] = this.lookupRef._searchState;
                t = 'search';
            } else {
                this.lookupRef._searchState = null;
            }

            const vals = this.lookupRef.selectionMgr.getSelectedIds();
            if (vals && vals.length) {
                p["selectedInfo"] = {
                    selected: true,
                    selectedIds: vals,
                };
            }
        }


        return this.lookupRef.httpMgr.lookupRequest(p, t, true).pipe(
            map((restData: LookupGridResult) => {
                let _items = this.lookupRef.items || [];
                if (restData) {
                    if (this.lookupRef.viewType === 'tag') {
                        this.lookupRef.lookupSelectionSer.loadSelections(
                            restData["selectedData"] || []
                        );
                    }
                    _items = restData.items || [];

                    if (restData.displayType.toLowerCase().indexOf('treelist') > -1 && _items.length && _items[0].data) {
                        _items = _items.map(n => n.data);
                    }
    
                    // return _items.slice(0, this.options.showItemsCount);

                } else {
                    if (this.lookupRef.displayText && this.lookupRef.isTextChange) {
                        if (restData.displayType.toLowerCase().indexOf('treelist') > -1 && _items.length && _items[0].data) {
                            _items = _items.map(n => n.data);
                        }

                        const items = _items.filter(n => {
                            return n[this.lookupRef.textField].indexOf(this.lookupRef.displayText) > -1;
                        }).slice(0, this.options.showItemsCount);
                        _items = items;

                        // return _items.slice(0, this.options.showItemsCount);
                    }
                }

                return _items.slice(0, this.options.showItemsCount);
            })
        );
    }

    private loadData() {
        const loadingRef = this.lookupRef.loadingService.show({container: this.panelElement});
        this.getData().subscribe((data: any) => {
            loadingRef.close();
            if (this.cmpRef && this.cmpRef.instance) {
                this.cmpRef.instance.loadData(data);
                if (data.length < this.options.showItemsCount) {
                    // let newHeight = data.length * 30 + (this.options.showMore ? 50: 0) + (this.options.footerHeight||0) + 5;
                    this.data = data;

                    let newHeight = this.cmpRef.instance.itemsContainer.nativeElement.querySelector('ul').offsetHeight + 10;

                    if (!data || !data.length) {
                        newHeight = 55;
                    }

                    this.cmpRef.instance.itemsContainer.nativeElement.style.height = `${newHeight}px`;
                    if (this.panelElement) {
                        if (this.panelElement.style.transformOrigin.indexOf('bottom') > -1) {
                            this.panelElement.style.top = `${this.getInputSizeInfo().top - newHeight - 5}px` ;
                        }
                        this.panelElement.style.height = 'auto';
                    }
                } else {
                    this.setPanelPosition();
                    this.cmpRef.instance.itemsContainer.nativeElement.style.height = '100%';
                    if (this.panelElement) {
                        this.render.removeStyle(this.panelElement, 'height');
                    }
                }

                if ((this.lookupRef.isTextChange || (this.lookupRef.tagInput && this.lookupRef.tagInput.value !== '') ||  
                    (this.lookupRef.inputGroup && this.lookupRef.inputGroup.value !== '' && this.lookupRef.isTextChange)) && data && data.length) {
                    this.cmpRef.instance.setActiveItem(0);
                }

                this.panelElement.style.overflow = 'auto';
            }
        });
    }


    @HostListener('keydown', ['$event'])
    registerKeyboardEvent($event: KeyboardEvent) {

        if (!this.lookupRef.singleSelect && this.lookupRef.viewType !== 'tag')  {
            return;
        }

        let rows= [];
        if (this.cmpRef) {
            rows = this.cmpRef.instance.data;
        }

        if (!rows || !rows.length) {
            return;
        }

        if ($event.code === 'ArrowUp' || $event.code === 'ArrowDown') {
            $event.preventDefault();
            $event.stopPropagation();
        }


        if ($event.code === 'Backspace' && this.lookupRef.viewType === 'tag' &&
            this.lookupRef.selections && this.lookupRef.selections.length &&
            this.lookupRef.tagInput && !this.lookupRef.tagInput.value && this.lookupRef.quickSelect.enableBackspace) {
            $event.preventDefault();
            $event.stopPropagation();
            const newdata = this.lookupRef.selections.slice(0, this.lookupRef.selections.length - 1);
            if (!newdata || !newdata.length) {
                this.lookupRef.clearValue(true);
            } else {
                this.lookupRef.selectItem(newdata);
            }
            this.lookupRef.lookupSelectionSer.loadSelections(newdata);
            this.setPanelPosition();
            return;
        }


        const idx = this.cmpRef.instance.activeIndex;
        let activeIndex = idx;

        const setActiveItem = (index) => {
            activeIndex = index;
            this.cmpRef.instance.setActiveItem(index);
        };

        if ($event.code === 'ArrowUp') {  // up
            if (idx > -1) {
                let prevIdx = idx - 1;
                if (prevIdx < 0) {
                    prevIdx = rows.length - 1;
                }
                setActiveItem(prevIdx);
            } else {
                setActiveItem(rows.length - 1);
            }
        }
        if ($event.code === 'ArrowDown') { // down
            let nextIdx = idx + 1;
            if (nextIdx >= rows.length) {
                nextIdx = 0;
            }

            setActiveItem(nextIdx);
        }

        if($event.key === 'Enter') {
            if (rows && rows.length && this.panelElement) {
                const data = rows[idx];
                this.selectItem(data);
            } else {
                this.inputRef.inputClick.emit($event);
            }
        }
    }
}